import React from "react";
import { Typography, Skeleton, Tooltip } from "@mui/material";
import { useGeocoding } from "../../hooks/useGeocoding";

interface AddressCellProps {
  latitude?: number;
  longitude?: number;
  priority?: number;
}

export const AddressCell: React.FC<AddressCellProps> = ({
  latitude,
  longitude,
  priority = 0,
}) => {
  const { address, loading, error, isFromCache } = useGeocoding(
    latitude,
    longitude,
    { priority }
  );

  if (loading) {
    return <Skeleton variant="text" width={120} height={20} />;
  }

  if (error) {
    return (
      <Tooltip title={error}>
        <Typography variant="body2" color="error">
          {address}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isFromCache ? "Depuis le cache" : "Récupéré via API"}>
      <Typography variant="body2">
        {address}
      </Typography>
    </Tooltip>
  );
};
